import * as React from "react";

const SvgComponent = (props) => (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 19C4.25329 19 0 14.7467 0 9.5C0 4.25329 4.25329 0 9.5 0C14.7467 0 19 4.25329 19 9.5C19 14.7467 14.7467 19 9.5 19ZM6.06232 9.51388L5.13411 10.504L8.39127 13.5576L13.5981 6.86303L12.5269 6.02983L8.23373 11.5496L6.06232 9.51388Z" fill="#68A107" />
    </svg>

);

export default SvgComponent;